<template>
  <div class="lg:max-w-7xl lg:mx-auto lg:py-4">
    <div
      class="mx-4 mb-4"
      v-if="$route.name === 'DashboardTrend' || $route.name === 'Dashboard'"
    >
      <div class="sm:hidden">
        <label for="tabs" class="sr-only">Select a tab</label>
        <select
          id="tabs"
          name="tabs"
          class="block w-full rounded-md border-gray-300 focus:border-teal-500 focus:ring-teal-500"
        >
          <option selected>{{ $t("Tendances sur 12 mois") }}</option>
          <option>{{ $t("Analyse personnalisée") }}</option>
        </select>
      </div>
      <div class="hidden sm:block">
        <nav
          class="isolate flex divide-x divide-gray-200 rounded-lg shadow"
          aria-label="Tabs"
        >
          <button
            @click="
              urlType
                ? changeTab(`/dashboard/${urlType}`)
                : changeTab(`/dashboard`)
            "
            :class="[
              $route.name === 'DashboardExpertStatistics' ||
              $route.name === 'Dashboard'
                ? 'bg-teal-600 text-white hover:bg-teal-700'
                : 'bg-white text-gray-700 hover:bg-gray-50 hover:text-gray-700',
              'group relative min-w-0 flex-1 overflow-hidden rounded-l-lg px-4 py-4 text-center text-md font-bold focus:z-10',
            ]"
          >
            <span>{{ $t("Analyse par période") }}</span>
            <span
              aria-hidden="true"
              :class="[
                $route.name === 'DashboardExpertStatistics' ||
                $route.name === 'Dashboard'
                  ? 'bg-white'
                  : 'bg-gray-300',
                'absolute inset-x-0 bottom-0 h-0.5',
              ]"
            ></span>
          </button>
          <button
            @click="
              urlType
                ? changeTab(`/dashboard/trend-analysis/${urlType}`)
                : changeTab(`/dashboard/trend-analysis`)
            "
            :class="[
              $route.name === 'DashboardExpertStatisticsTrend' ||
              $route.name === 'DashboardTrend'
                ? 'bg-teal-600 text-white hover:bg-teal-700'
                : 'bg-white text-gray-700 hover:bg-gray-50 hover:text-gray-700',
              'group relative min-w-0 flex-1 overflow-hidden rounded-r-lg px-4 py-4 text-center text-md font-bold focus:z-10',
            ]"
            aria-current="page"
          >
            <span>{{ $t("Tendances sur 12 mois") }}</span>
            <span
              aria-hidden="true"
              :class="[
                $route.name === 'DashboardExpertStatisticsTrend' ||
                $route.name === 'DashboardTrend'
                  ? 'bg-white'
                  : 'bg-gray-300',
                'absolute inset-x-0 bottom-0 h-0.5 ',
              ]"
            ></span>
          </button>
        </nav>
      </div>
    </div>
    <div
      class="col-span-4 flex mx-4 pb-3"
      v-if="
        $route.name === 'DashboardPerformanceExpertStatistics' ||
        $route.name === 'DashboardExpertStatisticsTrend'
      "
    >
      <!-- <div
    :class="[
     showSideNav ? 'beta__logo' : 'left-40',
     'fixed z-1  mt-1 text-xs',
    ]">
    <span
     class="inline-flex items-center rounded-md bg-teal-500 px-2 py-1 text-md font-medium text-green-100 ring-1 ring-inset ring-green-100 ring-opacity-20">
     <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor"
      class="w-4 h-4 mr-1">
      <path
       d="M15.98 1.804a1 1 0 00-1.96 0l-.24 1.192a1 1 0 01-.784.785l-1.192.238a1 1 0 000 1.962l1.192.238a1 1 0 01.785.785l.238 1.192a1 1 0 001.962 0l.238-1.192a1 1 0 01.785-.785l1.192-.238a1 1 0 000-1.962l-1.192-.238a1 1 0 01-.785-.785l-.238-1.192zM6.949 5.684a1 1 0 00-1.898 0l-.683 2.051a1 1 0 01-.633.633l-2.051.683a1 1 0 000 1.898l2.051.684a1 1 0 01.633.632l.683 2.051a1 1 0 001.898 0l.683-2.051a1 1 0 01.633-.633l2.051-.683a1 1 0 000-1.898l-2.051-.683a1 1 0 01-.633-.633L6.95 5.684zM13.949 13.684a1 1 0 00-1.898 0l-.184.551a1 1 0 01-.632.633l-.551.183a1 1 0 000 1.898l.551.183a1 1 0 01.633.633l.183.551a1 1 0 001.898 0l.184-.551a1 1 0 01.632-.633l.551-.183a1 1 0 000-1.898l-.551-.184a1 1 0 01-.633-.632l-.183-.551z" />
     </svg>
     {{ $t("beta") }}
    </span>
   </div> -->

      <PbxDashboardSelector
        :key="urlType"
        @action="setPeriod(selectedPeriod)"
        @all-selected="$emit('all-selected', $event)"
        :urlType="urlType"
        @elementToRemove="elementToRemove = $event"
        :queryElement="queryElement"
        :elements="this.pbxElements ? this.pbxElements : []"
        :isNotMultiple="true"
      />
    </div>
    <div
      v-if="
        pbxElements &&
        pbxElements?.length &&
        ($route.name === 'DashboardPerformanceExpertStatistics' ||
          $route.name === 'DashboardExpertStatisticsTrend')
      "
      class="pb-4 mx-4"
    >
      <div v-if="showLess" class="lg:grid grid-cols-8 gap-2">
        <span
          v-for="element in pbxElements.slice(0, 8)"
          :key="element"
          class="flex items-center justify-between px-2 rounded-full bg-gray-200 py-1 text-xs font-medium text-gray-700"
        >
          <span class="truncate" :title="element">
            {{ element }} -
            {{
              urlType && pbxMap
                ? urlType === "extension"
                  ? pbxMap?.extensions[element]
                  : urlType === "queue"
                  ? pbxMap?.call_queues[element]?.name
                  : ""
                : ""
            }}
          </span>
          <button
            type="button"
            @click="elementRemoved(element)"
            class="rounded-full text-gray-400 hover:bg-gray-200 hover:text-gray-500 focus:bg-gray-500 focus:text-white focus:outline-none"
          >
            <svg
              class="h-2 w-2"
              stroke="currentColor"
              fill="none"
              viewBox="0 0 8 8"
            >
              <path
                stroke-linecap="round"
                stroke-width="1.5"
                d="M1 1l6 6m0-6L1 7"
              />
            </svg>
          </button>
        </span>
        <!-- <div
    v-for="element in pbxElements.slice(0, 12)"
    :key="element"
    class="relative rounded-lg border border-gray-300 bg-whv-if="showLess"ite px-2 py-1 shadow-sm flex items-center hover:border-gray-400">
    <div @click="elementRemoved(element)" class="flex-1 min-w-0">
     <a
      :title="`Remove - ${element}`"
      class="focus:outline-none cursor-pointer">
      <span class="absolute inset-0" aria-hidden="true" />
      <p class="text-xs font-normal text-gray-900 truncate">
       {{ element }}
      </p>
     </a>
    </div>
   </div> -->
      </div>
      <div v-else class="lg:grid grid-cols-8 gap-2">
        <span
          v-for="element in pbxElements"
          :key="element"
          class="flex items-center justify-between px-2 rounded-full bg-gray-200 py-1 text-xs font-medium text-gray-700"
        >
          <span class="truncate" :title="element">
            {{ element }} -
            {{
              urlType && pbxMap
                ? urlType === "extension"
                  ? pbxMap?.extensions[element]
                  : urlType === "queue"
                  ? pbxMap?.call_queues[element]?.name
                  : ""
                : ""
            }}
          </span>
          <button
            type="button"
            @click="elementRemoved(element)"
            class="rounded-full text-gray-400 hover:bg-gray-200 hover:text-gray-500 focus:bg-gray-500 focus:text-white focus:outline-none"
          >
            <svg
              class="h-2 w-2"
              stroke="currentColor"
              fill="none"
              viewBox="0 0 8 8"
            >
              <path
                stroke-linecap="round"
                stroke-width="1.5"
                d="M1 1l6 6m0-6L1 7"
              />
            </svg>
          </button>
        </span>
      </div>
      <div v-show="pbxElements.length > 12" class="my-1">
        <span
          v-show="showLess"
          class="text-xs italic text-gray-500 flex justify-center"
        >
          {{ $t("andNumberMoreElements", { numb: pbxElements.length - 8 }) }}
        </span>
        <div class="flex justify-center mt-2">
          <button
            @click="showLess = !showLess"
            class="rounded-lg text-gray-700 bg-white hover:bg-grey-100 border-gray-300 hover:bg-gray-50 hover:shadow-md shadow-sm px-2 py-1 border text-xs"
          >
            {{ showLess ? $t("showMore") : $t("showLess") }}
          </button>
        </div>
      </div>
    </div>
    <!-- Standard dashboard -->
    <div
      v-if="
        $route.name === 'DashboardPerformanceExpertStatistics' ||
        $route.name === 'Dashboard'
      "
      class="lg:grid lg:grid-cols-4 lg:gap-4 sm:space-y-0 lg:space-y-0 md:mx-4"
    >
      <div class="col-span-4 flex justify-between mb-10">
        <div class="font-medium text-gray-700">
          <!-- <div
      :class="[
       $route.name === 'DashboardExpertStatistics' ? '' : 'left-32',
       'fixed z-1 ',
      ]">
      <span
       class="inline-flex items-center rounded-md bg-teal-500 px-2 py-1 text-md font-medium text-green-100 ring-1 ring-inset ring-green-100 ring-opacity-20 text-xs">
       <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        fill="currentColor"
        class="w-4 h-4 mr-1">
        <path
         d="M15.98 1.804a1 1 0 00-1.96 0l-.24 1.192a1 1 0 01-.784.785l-1.192.238a1 1 0 000 1.962l1.192.238a1 1 0 01.785.785l.238 1.192a1 1 0 001.962 0l.238-1.192a1 1 0 01.785-.785l1.192-.238a1 1 0 000-1.962l-1.192-.238a1 1 0 01-.785-.785l-.238-1.192zM6.949 5.684a1 1 0 00-1.898 0l-.683 2.051a1 1 0 01-.633.633l-2.051.683a1 1 0 000 1.898l2.051.684a1 1 0 01.633.632l.683 2.051a1 1 0 001.898 0l.683-2.051a1 1 0 01.633-.633l2.051-.683a1 1 0 000-1.898l-2.051-.683a1 1 0 01-.633-.633L6.95 5.684zM13.949 13.684a1 1 0 00-1.898 0l-.184.551a1 1 0 01-.632.633l-.551.183a1 1 0 000 1.898l.551.183a1 1 0 01.633.633l.183.551a1 1 0 001.898 0l.184-.551a1 1 0 01.632-.633l.551-.183a1 1 0 000-1.898l-.551-.184a1 1 0 01-.633-.632l-.183-.551z" />
       </svg>
       {{ $t("beta") }}
      </span>
     </div> -->

          <div
            class="fixed z-10"
            @mouseover="showDatePickers = true"
            @mouseleave="showDatePickers = false"
          >
            <div class="flex items-center gap-4 text-md">
              <div
                class="flex items-center bg-gray-500 text-white shadow-md rounded-md border-gray-500 z-10 cursor-pointer font-bold"
              >
                <p class="border-r px-2 py-2">
                  {{
                    toLocaleDateString(startDate) +
                    (selectedPeriod !== "day"
                      ? " - " + toLocaleDateString(endDate)
                      : "")
                  }}
                </p>
                <div
                  @click="showDatePickers = true"
                  class="px-2 py-2 cursor-pointer bg-white text-gray-500 shadow-md hover:text-white hover:bg-blue-400 rounded-r-md"
                >
                  <font-awesome-icon icon="calendar" class="flex-shrink-0" />
                </div>
              </div>
            </div>
            <transition name="fade">
              <div
                v-show="showDatePickers"
                class="space-y-1 transition ease-in-out delay-150 mt-1 px-1 text-left"
              >
                <div v-for="option in calendarOptions" :key="option.value">
                  <div v-if="option.value === 'custom'">
                    <v-date-picker
                      class="inline-block h-full w-full"
                      color="teal"
                      v-model="customDate"
                      :max-date="new Date()"
                      mode="date"
                      is-range
                    >
                      <template v-slot="{ togglePopover }">
                        <button
                          @click="togglePopover()"
                          :class="{
                            'bg-blue-500 text-white':
                              selectedPeriod === option.value,
                            'hover:bg-blue-600 hover:text-white':
                              selectedPeriod !== option.value,
                          }"
                          class="flex items-center text-xs px-4 py-2 rounded-md focus:outline-none bg-gray-400 text-white w-full text-left"
                        >
                          <font-awesome-icon
                            :icon="option.icon"
                            class="flex-shrink-0 mr-1.5"
                          />
                          {{ $t("dashboards.custom") }}
                        </button>
                      </template>
                    </v-date-picker>
                  </div>
                  <button
                    v-else
                    @click="selectPeriod(option.value)"
                    :class="{
                      'bg-blue-500 text-white': selectedPeriod === option.value,
                      'hover:bg-blue-600 hover:text-white':
                        selectedPeriod !== option.value,
                    }"
                    class="flex items-center text-xs px-4 py-2 rounded-md focus:outline-none bg-gray-400 text-white w-full text-left"
                  >
                    <font-awesome-icon
                      :icon="option.icon"
                      class="flex-shrink-0 mr-1.5"
                    />
                    {{ $t(option.name) }}
                  </button>
                </div>
                <div class="">
                  <TimeSelector
                    @timeSelector="setPeriod(selectedPeriod)"
                    :elements="this.pbxElements ? this.pbxElements : []"
                    :clearTimeSelector="clearTimeSelector"
                  />
                </div>
              </div>
            </transition>
          </div>
        </div>
        <div class="z-1 mt- flex lg:mt-0 gap-2">
          <!-- <span class="hidden sm:block">
      <button
       type="button"
       :title="$t('Envoyer un rapport')"
       class="inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-100 focus:outline-none encom_ring_color"
       @click="
        this.$refs.popupShareReport.show({
         title: $t('pbxReport.shareTitle'),
         message: $t('pbxReport.shareMessage'),
         isSchedule: false,
        })
       ">
       <font-awesome-icon
        icon="share"
        class="h-5 w-5 text-gray-500"
        aria-hidden="true" />
      </button>
     </span>

     <span class="hidden sm:block">
      <button
       type="button"
       :title="$t('Planifier un rapport')"
       class="inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-100 focus:outline-none encom_ring_color"
       @click="
        this.$refs.popupShareScheduleReport.show({
         title:
          $t('Planifier un rapport') +
          ' ' +
          $t('daily') +
          ', ' +
          $t('weekly') +
          ' ' +
          $t('or') +
          ' ' +
          $t('monthly'),
         message: $t('Le rapport a été planifié avec succès'),
         isSchedule: true,
        })
       ">
       <font-awesome-icon
        :icon="['far', 'calendar-check']"
        class="h-5 w-5 text-gray-500"
        aria-hidden="true" />
      </button>
     </span>
     <span class="hidden sm:block">
      <button
       type="button"
       :title="$t('Créer une alerte')"
       @click="
        this.$refs.popupCreateAlert.show({
         title: $t('Créer une alerte'),
         message: $t(''),
         isSchedule: false,
        })
       "
       class="inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-100 focus:outline-none encom_ring_color">
       <font-awesome-icon
        :icon="['far', 'bell']"
        class="h-5 w-5 text-gray-500"
        aria-hidden="true" />
      </button>
     </span> -->
          <div
            v-if="
              $route.name === 'Dashboard' &&
              this.$cookie.getCookie('API').includes('0585')
            "
            @click.prevent="this.$refs.tutorial.show()"
            title="Ouvrir le tutoriel"
            :class="['sm:ml-6 mt-0.5 text-xs cursor-pointer']"
          >
            <span
              class="shadow-md hover:shadow-lg inline-flex items-center rounded-full bg-blue-400 hover:bg-blue-500 px-2 py-2 hover:ring-1 hover:ring-inset hover:ring-blue-100 ring-opacity-20"
            >
              <font-awesome-icon
                icon="question"
                class="text-blue-100 h-5 w-5"
              />
            </span>
          </div>
        </div>
      </div>
      <div
        v-if="
          (lineChartSeries?.length > 0 ||
            barChartSeries?.length > 0 ||
            areaChartSeries?.length > 0 ||
            heatmapSeries?.length > 0 ||
            connectionOverviewData?.series?.length > 0 ||
            queueConnectionOverviewData?.series?.length > 0 ||
            statusBreakdownData?.radialSeries?.length > 0) &&
          pbxElements?.length > 0 &&
          !noDataForPeriod
        "
        class="lg:col-span-4 sm:col-span-1 space-y-2 pt-2 pb-12 bg-white shadow-md px-2 rounded-sm"
      >
        <div
          class="text-center items-center py-1 text-white bg-pale-sky rounded-lg shadow-md mx-0"
        >
          <h2 v-if="urlType === 'queue'" class="uppercase text-lg font-bold">
            Tableau de Bord des Performances des Files D'attente
          </h2>
          <h2
            v-if="urlType === 'extension'"
            class="uppercase text-lg font-bold"
          >
            Tableau de bord des Performances des Utiliateurs
          </h2>
        </div>
        <!-- KPI Cards -->
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
          <div
            v-for="(card, index) in kpiCards"
            :key="index"
            class="bg-white p-4 rounded-2xl shadow"
          >
            <div class="text-gray-500 text-sm">{{ card.title }}</div>
            <div class="text-2xl font-bold mt-1">{{ card.value }}</div>
          </div>
        </div>

        <!-- Charts -->
        <div class="gap-6">
          <div class="p-4 space-y-8">
            <div class="grid grid-cols-3 gap-8">
              <div v-if="lineChartSeries?.length" class="col-span-2">
                <LineChart
                  :series="lineChartSeries"
                  :categories="timeSlots"
                  :title="$t('performanceTrends')"
                />
              </div>
              <div
                v-if="statusBreakdownData?.radialSeries?.length"
                class="text-center items-center bg-white rounded-lg shadow pt-4"
              >
                <RadialBarChart
                  :series="statusBreakdownData.radialSeries"
                  :labels="statusBreakdownData.labels"
                  :title="$t('statusBreakdown')"
                />
              </div>
            </div>
            <div v-if="barChartSeries?.length" class="mt-8">
              <BarChart
                :series="barChartSeries"
                :categories="timeSlots"
                :title="$t('timeUtilization')"
                y-axis-title="Hours"
              />
            </div>
            <div v-if="heatmapSeries" class="mt-8">
              <HeatmapChart
                :series="heatmapSeries"
                :categories="timeSlots"
                :title="$t('multiQueuePerformanceHeatmap')"
              />
            </div>
            <div class="grid grid-cols-3 gap-8 mt-8">
              <div class="col-span-3">
                <AreaChart
                  v-if="areaChartSeries"
                  :series="areaChartSeries"
                  :categories="timeSlots"
                  :title="$t('timeDistribution')"
                />
              </div>
              <!-- <RadialBarChartStroked
        v-if="queueConnectionOverviewData.series"
        :series="queueConnectionOverviewData.series"
        :labels="queueConnectionOverviewData.labels"
        title="User's Status Distribution" /> -->
              <!-- <BarChart
        :series="barChartSeries"
        :categories="timeSlots"
        title="Minutes Breakdown" /> -->
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="noDataForPeriod && pbxElements?.length > 0"
        class="col-span-4 pb-12 space-y-2 py-2 bg-white shadow-md px-2 rounded-sm"
      >
        <div class="pt-8 overflow-x-auto sm:-mx-6 lg:-mx-0">
          <div class="text-center max-w-lg mx-auto space-y-4">
            <font-awesome-icon
              icon="gauge-high"
              class="mx-auto h-10 w-10 text-teal-600"
              aria-hidden="true"
            />
            <h1 class="text-gray-900 font-bold text-2xl">DASHBOARD</h1>
            <h3 class="mt-2 text-lg font-medium text-gray-900">
              <span>
                Il n'y a pas de données pour la période sélectionnée.
              </span>
            </h3>
            <div class="pt-10">
              <div
                class="max-w-md mx-12 py-1 font-bold flex justify-center gap-3 items-center text-center rounded-md border-teal-200 bg-teal-200 shadow-sm text-gray-900"
              >
                <font-awesome-icon
                  icon="fa-signs-post"
                  class="icon alt text-center items-center"
                />
                <p class="text-base">
                  Veuillez essayer de sélectionner d'autres dates.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="urlType ? !pbxElements || pbxElements?.length == 0 : false"
        class="col-span-4 pb-12 space-y-2 py-2 bg-white shadow-md px-2 rounded-sm"
      >
        <div
          class="text-center items-center py-1 text-white bg-pale-sky rounded-lg shadow-md mx-0"
        >
          <h2 v-if="urlType === 'queue'" class="uppercase text-lg font-bold">
            Tableau de Bord des Performances des Files D'attente
          </h2>
          <h2
            v-if="urlType === 'extension'"
            class="uppercase text-lg font-bold"
          >
            Tableau de bord des Performances des Utiliateurs
          </h2>
        </div>
        <div class="pt-8 overflow-x-auto sm:-mx-6 lg:-mx-0">
          <div
            v-if="!pbxElements || pbxElements.length <= 0"
            class="text-center max-w-lg mx-auto space-y-4"
          >
            <font-awesome-icon
              icon="gauge-high"
              class="mx-auto h-10 w-10 text-teal-600"
              aria-hidden="true"
            />
            <h1 class="text-gray-900 font-bold text-2xl">DASHBOARD</h1>
            <h3 class="mt-2 text-lg font-medium text-gray-900">
              <span v-if="urlType === 'queue'">
                Les indicateurs essentiels pour analyser la performance de vos
                files d’attente.
              </span>
              <span v-if="urlType === 'extension'">
                Les indicateurs essentiels pour analyser la performance par
                utilisateur.
              </span>
            </h3>
            <div class="pt-10">
              <PleaseSelectElement
                v-if="urlType === 'queue'"
                dataDescription="Veuillez sélectionner une file et une période"
              />
              <PleaseSelectElement
                v-if="urlType === 'extension'"
                dataDescription="Veuillez sélectionner un utilisateur et une période"
              />
            </div>
          </div>
          <div
            v-else
            class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-6"
          >
            <div class="overflow-hidden border-b border-gray-200 rounded-md">
              <NoData />
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="col-span-1" v-if="dataQueueTable.length">
    <TopQueuesCard :data="dataQueueTable" />
   </div> -->
    </div>
    <!-- KPI dashboard -->

    <TransitionRoot as="template" :show="reportList">
      <Dialog as="div" class="relative z-40" @close="reportList = false">
        <div class="fixed inset-0" />

        <div class="fixed inset-0 overflow-hidden">
          <div class="absolute inset-0 overflow-hidden">
            <div
              class="pointer-events-none fixed inset-y-0 right-0 top-12 flex max-w-full pl-10"
            >
              <TransitionChild
                as="template"
                enter="transform transition ease-in-out duration-500 sm:duration-700"
                enter-from="translate-x-full"
                enter-to="translate-x-0"
                leave="transform transition ease-in-out duration-500 sm:duration-700"
                leave-from="translate-x-0"
                leave-to="translate-x-full"
              >
                <DialogPanel class="pointer-events-auto w-screen ml-64">
                  <div
                    class="flex h-full flex-col overflow-y-scroll bg-white py-6 shadow-xl"
                  >
                    <div class="px-4 sm:px-6">
                      <div class="flex items-start justify-between">
                        <DialogTitle
                          class="w-full text-lg font-medium text-gray-900"
                        >
                          <div
                            class="text-center items-center py-1 text-white bg-pale-sky rounded-lg shadow-md mx-0"
                          >
                            <h2 class="uppercase text-lg font-bold">
                              MES RAPPORTS PROGRAMMES
                            </h2>
                          </div>
                        </DialogTitle>
                        <div class="ml-3 flex h-7 items-center">
                          <button
                            type="button"
                            class="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none"
                            @click="reportList = false"
                          >
                            <span class="sr-only">Close panel</span>
                            <XIcon class="h-6 w-6" aria-hidden="true" />
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="relative mt-4 flex-1">
                      <!-- Replace with your content -->
                      <div
                        class="absolute border-gray-200 bg-white w-full pb-2"
                      >
                        <div class="flex flex-col mb-0">
                          <div class="-my-0 overflow-x-auto sm:-mx-6 lg:-mx-0">
                            <div
                              class="py-4 align-middle inline-block min-w-full sm:px-4 lg:px-4"
                            >
                              <div
                                class="shadow overflow-hidden border-b border-gray-200 rounded-md items-center"
                              >
                                <div
                                  class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg items-center"
                                >
                                  <table
                                    class="min-w-full divide-y divide-gray-300 items-center"
                                  >
                                    <thead class="bg-gray-50">
                                      <tr>
                                        <!-- Render the th element only if header.name is not 'id' -->
                                        <template
                                          v-for="(header, index) in thead"
                                        >
                                          <th
                                            v-if="header.name !== 'id'"
                                            :key="index"
                                            scope="col"
                                            :class="{
                                              'pl-4 pr-3 sm:pl-6': index === 1,
                                              'px-3': index !== 1,
                                            }"
                                            class="py-3.5 text-left text-sm font-semibold text-gray-900 capitalize"
                                          >
                                            <span
                                              v-if="
                                                header.name.includes('_') &&
                                                !header.name.includes(
                                                  'pattern',
                                                ) &&
                                                header.name !== 'start_at'
                                              "
                                            >
                                              {{
                                                $t(header.name.split("_")[1])
                                              }}
                                            </span>
                                            <span
                                              v-else-if="header.name === 'dns'"
                                            >
                                              élément
                                            </span>
                                            <span
                                              v-else-if="
                                                header.name === 'repeat'
                                              "
                                            >
                                              Planifié
                                            </span>
                                            <span
                                              v-else-if="
                                                header.name === 'start_at'
                                              "
                                            >
                                              Début
                                            </span>
                                            <span
                                              v-else-if="
                                                header.name === 'repeat_pattern'
                                              "
                                            >
                                              Chaque
                                            </span>
                                            <span
                                              v-else-if="header.name === 'name'"
                                            >
                                              {{ $t("name") }}
                                            </span>
                                            <span
                                              v-else-if="
                                                header.name === 'element_type'
                                              "
                                            >
                                              {{ $t("type") }}
                                            </span>
                                            <span v-else>
                                              {{ $t(header.name) }}
                                            </span>
                                          </th>
                                        </template>
                                        <th
                                          scope="col"
                                          class="relative py-3.5 pl-3 pr-4 sm:pr-6"
                                        >
                                          <span class="sr-only">Edit</span>
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody
                                      class="divide-y divide-gray-200 bg-white truncate items-center"
                                    >
                                      <slot
                                        :row="row"
                                        v-for="(row, rowIndex) in tbody"
                                        :key="rowIndex"
                                        class="items-center"
                                      >
                                        <tr class="items-center">
                                          <!-- Render the td element only if the key is not 'id' -->
                                          <template
                                            v-for="(value, key, index) in row"
                                          >
                                            <td
                                              v-if="
                                                key !== 'id' &&
                                                key !== 'report_type'
                                              "
                                              :key="key"
                                              :class="{
                                                'pl-4 pr-3 sm:pl-6 font-medium text-gray-900':
                                                  index === 1,
                                                'px-3 text-gray-500':
                                                  index !== 1,
                                              }"
                                              class="whitespace-nowrap text-sm py-4 truncate max-w-xs"
                                            >
                                              <span
                                                class="truncate"
                                                v-if="value"
                                              >
                                                <span
                                                  v-if="
                                                    key === 'start_at' ||
                                                    key === 'end'
                                                  "
                                                >
                                                  <span
                                                    v-if="
                                                      row['repeat'] == 1 &&
                                                      key === 'end'
                                                    "
                                                  >
                                                    <svg
                                                      xmlns="http://www.w3.org/2000/svg"
                                                      viewBox="0 0 20 20"
                                                      fill="currentColor"
                                                      class="w-5 h-5"
                                                    >
                                                      <path
                                                        d="M6.75 9.25a.75.75 0 000 1.5h6.5a.75.75 0 000-1.5h-6.5z"
                                                      />
                                                    </svg>
                                                  </span>
                                                  <span
                                                    v-else-if="
                                                      row['repeat'] == 1 &&
                                                      key === 'start'
                                                    "
                                                  >
                                                    {{
                                                      $d(
                                                        new Date(
                                                          row["start_at"],
                                                        ),
                                                        "shortText",
                                                        "fr",
                                                      )
                                                    }}
                                                  </span>
                                                  <span v-else>
                                                    {{
                                                      $d(
                                                        new Date(value),
                                                        "shortText",
                                                        "fr",
                                                      )
                                                    }}
                                                  </span>
                                                </span>
                                                <span
                                                  v-else-if="key === 'repeat'"
                                                >
                                                  <div v-if="value">
                                                    <span
                                                      class="px-2 py-1 bg-green-200 text-green-600 rounded-xl"
                                                      >Oui</span
                                                    >
                                                  </div>
                                                  <div v-else>
                                                    <span
                                                      class="px-2 py-1 bg-blue-300 text-blue-600"
                                                      >Non</span
                                                    >
                                                  </div>
                                                </span>

                                                <span
                                                  v-else-if="
                                                    key === 'report_type'
                                                  "
                                                >
                                                  {{
                                                    value === "origins"
                                                      ? "Origine"
                                                      : value === "didReport"
                                                      ? "Rapport détaillé"
                                                      : value === "report"
                                                      ? "Rapport détaillé"
                                                      : value === "dashboard"
                                                      ? "Tableau de bord"
                                                      : value === "dashboard"
                                                      ? "Tableau de bord"
                                                      : $t(value)
                                                  }}
                                                </span>
                                                <span
                                                  v-else-if="
                                                    key === 'element_type'
                                                  "
                                                >
                                                  {{
                                                    value == 0
                                                      ? $t("extension")
                                                      : value == 4
                                                      ? $t("queue")
                                                      : value == "did"
                                                      ? $t("number")
                                                      : value == "*"
                                                      ? "Tableau de bord"
                                                      : $t(value)
                                                  }}
                                                </span>
                                                <span v-else-if="key === 'dns'">
                                                  <span v-if="value === '*'">
                                                    <svg
                                                      xmlns="http://www.w3.org/2000/svg"
                                                      viewBox="0 0 20 20"
                                                      fill="currentColor"
                                                      class="w-5 h-5"
                                                    >
                                                      <path
                                                        d="M6.75 9.25a.75.75 0 000 1.5h6.5a.75.75 0 000-1.5h-6.5z"
                                                      />
                                                    </svg>
                                                  </span>
                                                  <span v-else>
                                                    <!-- {{ value.split(",") }} -->
                                                    <div
                                                      v-if="
                                                        showLessReport.indexOf(
                                                          rowIndex,
                                                        ) < 0
                                                      "
                                                      class="space-y-1"
                                                    >
                                                      <span
                                                        v-for="element in value
                                                          .split(',')
                                                          .slice(0, 2)"
                                                        :key="element"
                                                        class="flex items-center justify-between px-2 rounded-full bg-gray-200 py-1 text-xs font-medium text-gray-700"
                                                      >
                                                        <span
                                                          class="truncate"
                                                          :title="element"
                                                        >
                                                          {{ element }} -
                                                          {{
                                                            row[
                                                              "element_type"
                                                            ] && pbxMap
                                                              ? row[
                                                                  "element_type"
                                                                ] == 0
                                                                ? pbxMap
                                                                    ?.extensions[
                                                                    element
                                                                  ]
                                                                : row[
                                                                    "element_type"
                                                                  ] == 4
                                                                ? pbxMap
                                                                    ?.call_queues[
                                                                    element
                                                                  ]?.name
                                                                : ""
                                                              : ""
                                                          }}
                                                        </span>
                                                      </span>
                                                    </div>
                                                    <div
                                                      v-else
                                                      class="space-y-1"
                                                    >
                                                      <span
                                                        v-for="element in value.split(
                                                          ',',
                                                        )"
                                                        :key="element"
                                                        class="flex items-center justify-between px-2 rounded-full bg-gray-200 py-1 text-xs font-medium text-gray-700"
                                                      >
                                                        <span
                                                          class="truncate"
                                                          :title="element"
                                                        >
                                                          {{ element }} -
                                                          {{
                                                            row[
                                                              "element_type"
                                                            ] && pbxMap
                                                              ? row[
                                                                  "element_type"
                                                                ] == 0
                                                                ? pbxMap
                                                                    ?.extensions[
                                                                    element
                                                                  ]
                                                                : row[
                                                                    "element_type"
                                                                  ] == 4
                                                                ? pbxMap
                                                                    ?.call_queues[
                                                                    element
                                                                  ]?.name
                                                                : ""
                                                              : ""
                                                          }}
                                                        </span>
                                                      </span>
                                                    </div>
                                                    <div
                                                      v-show="
                                                        value.split(',')
                                                          .length > 2
                                                      "
                                                      class=""
                                                    >
                                                      <span
                                                        v-show="
                                                          showLessReport.indexOf(
                                                            rowIndex,
                                                          ) < 0
                                                        "
                                                        class="text-xs italic text-gray-500 flex justify-center"
                                                      >
                                                        {{
                                                          $t(
                                                            "andNumberMoreElements",
                                                            {
                                                              numb:
                                                                value.split(",")
                                                                  .length - 2,
                                                            },
                                                          )
                                                        }}
                                                      </span>
                                                      <div
                                                        class="flex justify-center mt-2"
                                                      >
                                                        <button
                                                          @click="
                                                            showLessReport.indexOf(
                                                              rowIndex,
                                                            ) >= 0
                                                              ? showLessReport.splice(
                                                                  showLessReport.indexOf(
                                                                    rowIndex,
                                                                  ),
                                                                  1,
                                                                )
                                                              : showLessReport.push(
                                                                  rowIndex,
                                                                )
                                                          "
                                                          class="rounded-lg text-gray-700 bg-white px-1 py-0.5 text-xs"
                                                        >
                                                          {{
                                                            showLessReport.indexOf(
                                                              rowIndex,
                                                            ) < 0
                                                              ? $t("showMore")
                                                              : $t("showLess")
                                                          }}...
                                                        </button>
                                                      </div>
                                                    </div>
                                                  </span>
                                                </span>
                                                <span
                                                  v-else-if="key === 'email'"
                                                >
                                                  <span>
                                                    <!-- {{ value.split(",") }} -->
                                                    <div
                                                      v-if="
                                                        showLessMail.indexOf(
                                                          rowIndex,
                                                        ) < 0
                                                      "
                                                      class="space-y-1"
                                                    >
                                                      <span
                                                        v-for="mail in value
                                                          .split(',')
                                                          .slice(0, 2)"
                                                        :key="mail"
                                                        class="flex items-center justify-between px-2 rounded-full bg-gray-200 py-1 text-xs font-medium text-gray-700"
                                                      >
                                                        <span
                                                          class="truncate"
                                                          :title="mail"
                                                        >
                                                          {{ mail }}
                                                        </span>
                                                      </span>
                                                    </div>
                                                    <div
                                                      v-else
                                                      class="space-y-1"
                                                    >
                                                      <span
                                                        v-for="mail in value.split(
                                                          ',',
                                                        )"
                                                        :key="mail"
                                                        class="flex items-center justify-between px-2 rounded-full bg-gray-200 py-1 text-xs font-medium text-gray-700"
                                                      >
                                                        <span
                                                          class="truncate"
                                                          :title="mail"
                                                        >
                                                          {{ mail }}
                                                        </span>
                                                      </span>
                                                    </div>
                                                    <div
                                                      v-show="
                                                        value.split(',')
                                                          .length > 2
                                                      "
                                                      class=""
                                                    >
                                                      <span
                                                        v-show="
                                                          showLessMail.indexOf(
                                                            rowIndex,
                                                          ) < 0
                                                        "
                                                        class="text-xs italic text-gray-500 flex justify-center"
                                                      >
                                                        {{
                                                          $t(
                                                            "andNumberMoreElements",
                                                            {
                                                              numb:
                                                                value.split(",")
                                                                  .length - 2,
                                                            },
                                                          )
                                                        }}
                                                      </span>
                                                      <div
                                                        class="flex justify-center mt-2"
                                                      >
                                                        <button
                                                          @click="
                                                            showLessMail.indexOf(
                                                              rowIndex,
                                                            ) >= 0
                                                              ? showLessMail.splice(
                                                                  showLessMail.indexOf(
                                                                    rowIndex,
                                                                  ),
                                                                  1,
                                                                )
                                                              : showLessMail.push(
                                                                  rowIndex,
                                                                )
                                                          "
                                                          class="rounded-lg text-gray-700 bg-white px-1 py-0.5 text-xs"
                                                        >
                                                          {{
                                                            showLessMail.indexOf(
                                                              rowIndex,
                                                            ) < 0
                                                              ? $t("showMore")
                                                              : $t("showLess")
                                                          }}...
                                                        </button>
                                                      </div>
                                                    </div>
                                                  </span>
                                                </span>
                                                <span
                                                  v-else-if="
                                                    key === 'resource_group'
                                                  "
                                                >
                                                  {{
                                                    tbody[rowIndex][
                                                      "resource_group"
                                                    ]["name"]
                                                  }}
                                                </span>
                                                <span v-else>
                                                  {{ $t(value) }}
                                                </span>
                                              </span>
                                              <span v-else>
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  viewBox="0 0 20 20"
                                                  fill="currentColor"
                                                  class="w-5 h-5"
                                                >
                                                  <path
                                                    d="M6.75 9.25a.75.75 0 000 1.5h6.5a.75.75 0 000-1.5h-6.5z"
                                                  />
                                                </svg>
                                              </span>
                                            </td>
                                          </template>
                                          <td
                                            class="px-3 text-gray-500 whitespace-nowrap text-sm py-4 truncate max-w-xs"
                                          >
                                            <div class="flex items-center">
                                              <a
                                                :href="`https://presentation.cx-engine.net/${row.report_type}/${row.id}`"
                                                target="_blank"
                                                :class="[
                                                  'relative -ml-px flex items-center bg-white px-2 py-1 text-sm font-semibold text-gray-700 hover:text-teal-600 ring-1 ring-inset ring-gray-300 hover:bg-teal-100 focus:z-10',
                                                ]"
                                              >
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  viewBox="0 0 20 20"
                                                  fill="currentColor"
                                                  class="w-5 h-5"
                                                >
                                                  <path
                                                    d="M10 12.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
                                                  />
                                                  <path
                                                    fill-rule="evenodd"
                                                    d="M.664 10.59a1.651 1.651 0 0 1 0-1.186A10.004 10.004 0 0 1 10 3c4.257 0 7.893 2.66 9.336 6.41.147.381.146.804 0 1.186A10.004 10.004 0 0 1 10 17c-4.257 0-7.893-2.66-9.336-6.41ZM14 10a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"
                                                    clip-rule="evenodd"
                                                  />
                                                </svg>
                                              </a>
                                              <button
                                                @click="
                                                  this.$refs.popupEditReport.show(
                                                    {
                                                      title: row.name,
                                                      id: row.id,
                                                      email: row.email,
                                                      dns: row.dns,
                                                      type: row.element_type,
                                                      group: row.resource_group
                                                        ?.id
                                                        ? row.resource_group?.id
                                                        : '',
                                                    },
                                                  )
                                                "
                                                type="button"
                                                :class="[
                                                  'relative -ml-px flex items-center bg-white px-2 py-1 text-sm font-semibold text-gray-700 hover:text-teal-600 ring-1 ring-inset ring-gray-300 hover:bg-teal-100 focus:z-10',
                                                ]"
                                              >
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  class="h-5 w-5"
                                                  viewBox="0 0 20 20"
                                                  fill="currentColor"
                                                >
                                                  <path
                                                    d="M17.414 2.586a2 2 0 00-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 000-2.828z"
                                                  />
                                                  <path
                                                    fill-rule="evenodd"
                                                    d="M2 6a2 2 0 012-2h4a1 1 0 010 2H4v10h10v-4a1 1 0 112 0v4a2 2 0 01-2 2H4a2 2 0 01-2-2V6z"
                                                    clip-rule="evenodd"
                                                  />
                                                </svg>
                                              </button>
                                              <button
                                                @click.prevent="
                                                  deleteItem(
                                                    row.id,
                                                    $t('delete'),
                                                    $t('confirmationMessage'),
                                                    $t('confirm'),
                                                    $t('goBack'),
                                                    $t('successMsg'),
                                                  )
                                                "
                                                type="button"
                                                :class="[
                                                  'hover:bg-red-50 hover:text-red-500 hover:ring-inset hover:ring-1 hover:ring-red-500 flex items-center text-gray-700 relative -ml-px bg-white px-2 py-1 text-sm font-semibold ring-1 ring-inset ring-gray-300 focus:z-10',
                                                ]"
                                              >
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  viewBox="0 0 20 20"
                                                  fill="currentColor"
                                                  class="w-5 h-5"
                                                >
                                                  <path
                                                    fill-rule="evenodd"
                                                    d="M8.75 1A2.75 2.75 0 006 3.75v.443c-.795.077-1.584.176-2.365.298a.75.75 0 10.23 1.482l.149-.022.841 10.518A2.75 2.75 0 007.596 19h4.807a2.75 2.75 0 002.742-2.53l.841-10.52.149.023a.75.75 0 00.23-1.482A41.03 41.03 0 0014 4.193V3.75A2.75 2.75 0 0011.25 1h-2.5zM10 4c.84 0 1.673.025 2.5.075V3.75c0-.69-.56-1.25-1.25-1.25h-2.5c-.69 0-1.25.56-1.25 1.25v.325C8.327 4.025 9.16 4 10 4zM8.58 7.72a.75.75 0 00-1.5.06l.3 7.5a.75.75 0 101.5-.06l-.3-7.5zm4.34.06a.75.75 0 10-1.5-.06l-.3 7.5a.75.75 0 101.5.06l.3-7.5z"
                                                    clip-rule="evenodd"
                                                  />
                                                </svg>
                                              </button>
                                            </div>
                                          </td>
                                        </tr>
                                      </slot>
                                    </tbody>
                                  </table>
                                  <PaginationComponent
                                    :current_page="dataReports?.current_page"
                                    :first_page_url="
                                      dataReports?.first_page_url
                                    "
                                    :from="dataReports?.from"
                                    :last_page="dataReports?.last_page"
                                    :last_page_url="dataReports?.last_page_url"
                                    :links="dataReports?.links"
                                    :next_page_url="dataReports?.next_page_url"
                                    :per_page="dataReports?.per_page"
                                    :to="dataReports?.to"
                                    :total="dataReports?.total"
                                    @action="$emit('action', $event)"
                                    @previousPage="previousPage()"
                                    @nextPage="nextPage()"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- <div v-else class="pt-20">
             <svg
              xmlns="http://www.w3.org/2000/svg"
              class="mx-auto h-12 w-12 text-gray-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor">
              <path
               stroke-linecap="round"
               stroke-linejoin="round"
               stroke-width="2"
               d="M7 12l3-3 3 3 4-4M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z" />
             </svg>
             <h3 class="mt-2 text-lg font-medium text-gray-900">
              {{ $t("queueHasNoData") }}
             </h3>
            </div> -->
                      </div>
                      <!-- /End replace -->
                    </div>
                  </div>
                </DialogPanel>
              </TransitionChild>
            </div>
          </div>
        </div>
      </Dialog>
    </TransitionRoot>

    <TransitionRoot as="template" :show="alertList">
      <Dialog as="div" class="relative z-40" @close="alertList = false">
        <div class="fixed inset-0" />

        <div class="fixed inset-0 overflow-hidden">
          <div class="absolute inset-0 overflow-hidden">
            <div
              class="pointer-events-none fixed inset-y-0 right-0 top-12 flex max-w-full pl-10"
            >
              <TransitionChild
                as="template"
                enter="transform transition ease-in-out duration-500 sm:duration-700"
                enter-from="translate-x-full"
                enter-to="translate-x-0"
                leave="transform transition ease-in-out duration-500 sm:duration-700"
                leave-from="translate-x-0"
                leave-to="translate-x-full"
              >
                <DialogPanel class="pointer-events-auto w-screen max-w-3xl">
                  <div
                    class="flex h-full flex-col overflow-y-scroll bg-white py-6 shadow-xl"
                  >
                    <div class="px-4 sm:px-6">
                      <div class="flex items-start justify-between">
                        <DialogTitle
                          class="w-full text-lg font-medium text-gray-900"
                        >
                          <div
                            class="text-center items-center py-1 text-white bg-pale-sky rounded-lg shadow-md mx-0"
                          >
                            <h2 class="uppercase text-lg font-bold">
                              MES ALERTES PROGRAMMEES
                            </h2>
                          </div>
                          <!-- {{ $t("agentDetails", { agentNumber: agentNumber, agentName: agentName }) }} -->
                        </DialogTitle>
                        <div class="ml-3 flex h-7 items-center">
                          <button
                            type="button"
                            class="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none"
                            @click="alertList = false"
                          >
                            <span class="sr-only">Close panel</span>
                            <XIcon class="h-6 w-6" aria-hidden="true" />
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="relative mt-4 flex-1">
                      <!-- Replace with your content -->
                      <div
                        class="absolute border-gray-200 bg-white w-full pb-2"
                      >
                        <div class="flex flex-col mb-0">
                          <div class="-my-0 overflow-x-auto sm:-mx-6 lg:-mx-0">
                            <div
                              class="py-4 align-middle inline-block min-w-full sm:px-4 lg:px-4"
                            >
                              <div
                                class="shadow overflow-hidden border-b border-gray-200 rounded-md"
                              >
                                <div
                                  class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg"
                                >
                                  <table
                                    class="min-w-full divide-y divide-gray-300"
                                  >
                                    <thead class="bg-gray-50">
                                      <tr>
                                        <!-- Render the th element only if header.name is not 'id' -->
                                        <template
                                          v-for="(header, index) in theadAlert"
                                        >
                                          <th
                                            v-if="header.name !== 'id'"
                                            :key="index"
                                            scope="col"
                                            :class="{
                                              'pl-4 pr-3 sm:pl-6': index === 1,
                                              'px-3': index !== 1,
                                            }"
                                            class="py-3.5 text-left text-sm font-semibold text-gray-900 capitalize"
                                          >
                                            <span
                                              v-if="
                                                header.name.includes('_') &&
                                                !header.name.includes(
                                                  'pattern',
                                                ) &&
                                                !header.name === 'start_at'
                                              "
                                            >
                                              {{
                                                $t(header.name.split("_")[1])
                                              }}
                                            </span>
                                            <span
                                              v-else-if="
                                                header.name === 'repeat'
                                              "
                                            >
                                              Planifié
                                            </span>
                                            <span
                                              v-else-if="
                                                header.name === 'repeat_pattern'
                                              "
                                            >
                                              Chaque
                                            </span>
                                            <span v-else>
                                              {{ $t(header.name) }}
                                            </span>
                                          </th>
                                        </template>
                                        <th
                                          scope="col"
                                          class="relative py-3.5 pl-3 pr-4 sm:pr-6"
                                        >
                                          <span class="sr-only">Edit</span>
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody
                                      class="divide-y divide-gray-200 bg-white truncate"
                                    >
                                      <slot
                                        :row="row"
                                        v-for="(row, rowIndex) in tbodyAlert"
                                        :key="rowIndex"
                                      >
                                        <tr>
                                          <!-- Render the td element only if the key is not 'id' -->
                                          <template
                                            v-for="(value, key, index) in row"
                                          >
                                            <td
                                              v-if="
                                                key !== 'id' &&
                                                key !== 'start_at'
                                              "
                                              :key="key"
                                              :class="{
                                                'pl-4 pr-3 sm:pl-6 font-medium text-gray-900':
                                                  index === 1,
                                                'px-3 text-gray-500':
                                                  index !== 1,
                                              }"
                                              class="whitespace-nowrap text-sm py-4 truncate max-w-sm"
                                            >
                                              <span
                                                class="truncate"
                                                v-if="value || key === 'start'"
                                              >
                                                <span
                                                  v-if="
                                                    key === 'start' ||
                                                    key === 'end'
                                                  "
                                                >
                                                  <span
                                                    v-if="
                                                      row['repeat'] == 1 &&
                                                      key === 'start'
                                                    "
                                                  >
                                                    {{
                                                      $d(
                                                        new Date(
                                                          row["start_at"],
                                                        ),
                                                        "shortText",
                                                        "fr",
                                                      )
                                                    }}
                                                  </span>
                                                  <span v-else>
                                                    {{
                                                      $d(
                                                        new Date(
                                                          row["start_at"],
                                                        ),
                                                        "shortText",
                                                        "fr",
                                                      )
                                                    }}
                                                  </span>
                                                </span>
                                                <span
                                                  v-else-if="key === 'repeat'"
                                                >
                                                  <div v-if="value">
                                                    <span
                                                      class="px-2 py-1 bg-green-200 text-green-600 rounded-xl"
                                                      >Oui</span
                                                    >
                                                  </div>
                                                  <div v-else>
                                                    <span
                                                      class="px-2 py-1 bg-blue-300 text-blue-600"
                                                      >Non</span
                                                    >
                                                  </div>
                                                </span>
                                                <span v-else>
                                                  {{ $t(value) }}
                                                </span>
                                              </span>
                                              <span v-else>
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  viewBox="0 0 20 20"
                                                  fill="currentColor"
                                                  class="w-5 h-5"
                                                >
                                                  <path
                                                    d="M6.75 9.25a.75.75 0 000 1.5h6.5a.75.75 0 000-1.5h-6.5z"
                                                  />
                                                </svg>
                                              </span>
                                            </td>
                                          </template>
                                          <td
                                            class="px-6 py-6 whitespace-nowrap text-right text-sm font-medium flex justify-end items-center gap-2"
                                          >
                                            <button
                                              @click.prevent="
                                                deleteItemAlert(
                                                  row.id,
                                                  $t('delete'),
                                                  $t('confirmationMessage'),
                                                  $t('confirm'),
                                                  $t('goBack'),
                                                  $t('successMsg'),
                                                )
                                              "
                                              type="button"
                                              :class="[
                                                'hover:bg-red-50 hover:text-red-500 hover:ring-inset hover:ring-1 hover:ring-red-500 text-gray-700 relative -ml-px inline-flex items-center bg-white px-2 py-1 text-sm font-semibold ring-1 ring-inset ring-gray-300 focus:z-10',
                                              ]"
                                            >
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 20 20"
                                                fill="currentColor"
                                                class="w-5 h-5"
                                              >
                                                <path
                                                  fill-rule="evenodd"
                                                  d="M8.75 1A2.75 2.75 0 006 3.75v.443c-.795.077-1.584.176-2.365.298a.75.75 0 10.23 1.482l.149-.022.841 10.518A2.75 2.75 0 007.596 19h4.807a2.75 2.75 0 002.742-2.53l.841-10.52.149.023a.75.75 0 00.23-1.482A41.03 41.03 0 0014 4.193V3.75A2.75 2.75 0 0011.25 1h-2.5zM10 4c.84 0 1.673.025 2.5.075V3.75c0-.69-.56-1.25-1.25-1.25h-2.5c-.69 0-1.25.56-1.25 1.25v.325C8.327 4.025 9.16 4 10 4zM8.58 7.72a.75.75 0 00-1.5.06l.3 7.5a.75.75 0 101.5-.06l-.3-7.5zm4.34.06a.75.75 0 10-1.5-.06l-.3 7.5a.75.75 0 101.5.06l.3-7.5z"
                                                  clip-rule="evenodd"
                                                />
                                              </svg>
                                            </button>
                                          </td>
                                        </tr>
                                      </slot>
                                    </tbody>
                                  </table>
                                  <PaginationComponent
                                    :current_page="dataAlerts.current_page"
                                    :first_page_url="dataAlerts.first_page_url"
                                    :from="dataAlerts.from"
                                    :last_page="dataAlerts.last_page"
                                    :last_page_url="dataAlerts.last_page_url"
                                    :links="dataAlerts.links"
                                    :next_page_url="dataAlerts.next_page_url"
                                    :per_page="dataAlerts.per_page"
                                    :to="dataAlerts.to"
                                    :total="dataAlerts.total"
                                    @action="$emit('action', $event)"
                                    @previousPage="previousPageAlert()"
                                    @nextPage="nextPageAlert()"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- <div v-else class="pt-20">
             <svg
              xmlns="http://www.w3.org/2000/svg"
              class="mx-auto h-12 w-12 text-gray-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor">
              <path
               stroke-linecap="round"
               stroke-linejoin="round"
               stroke-width="2"
               d="M7 12l3-3 3 3 4-4M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z" />
             </svg>
             <h3 class="mt-2 text-lg font-medium text-gray-900">
              {{ $t("queueHasNoData") }}
             </h3>
            </div> -->
                      </div>
                      <!-- /End replace -->
                    </div>
                  </div>
                </DialogPanel>
              </TransitionChild>
            </div>
          </div>
        </div>
      </Dialog>
    </TransitionRoot>
    <!-- <div
   v-if="dataAnswerTime.length && labelAnswerTime.length && dataQueueTable.length > 0 && dataSeriesOrigin.length && dataSeriesOrigin[0] && dataSeriesOrigin[0].data && dataSeriesOriginTop.length && dataSeriesOriginTop[0] && dataSeriesOriginTop[0].data"
   class="lg:flex lg:gap-4 sm:space-y-4 lg:space-y-0"
  >
   <QueueAnswerTimeCard :series="dataAnswerTime" :labels="labelAnswerTime" />
   <OriginsCard :key="dataSeriesOrigin[0]" v-show="dataSeriesOrigin[0].data" :data="dataSeriesOrigin[0].data" @quickPeriod="quickPeriodOrigin = $event" :quickPeriod="quickPeriodOrigin" @selectPeriod="periodSelectorOrigin = $event" />
   <OriginsTopCard :key="dataSeriesOriginTop[0]" v-show="dataSeriesOriginTop[0].data" :data="dataSeriesOriginTop[0].data" @quickPeriod="quickPeriodOriginTop = $event" :quickPeriod="quickPeriodOriginTop" @selectPeriod="periodSelectorOriginTop = $event" />
  </div> -->
  </div>
  <PopupShareReportDashboard
    ref="popupShareReport"
    :timeOption="this.buttonSelected"
    :elementOption="this.urlType"
    :parseDateRange="parseDateRange"
    :periodSelector="this.periodSelector"
    :selectHostName="this.hostName"
    selectHostContext="0"
    :startDate="startDate"
    :endDate="endDate"
    @activeBanner="$emit('activeBanner')"
    @successMsg="$emit('successMsg', $event)"
    @success="$emit('success', $event), $event ? getReportList() : ''"
    @reportList="reportList = true"
  />
  <PopupShareReportDashboard
    ref="popupShareScheduleReport"
    :timeOption="this.buttonSelected"
    :elementOption="this.urlType"
    :parseDateRange="parseDateRange"
    :periodSelector="this.periodSelector"
    :selectHostName="this.hostName"
    selectHostContext="0"
    :startDate="startDate"
    :endDate="endDate"
    @activeBanner="$emit('activeBanner')"
    @successMsg="$emit('successMsg', $event)"
    @success="$emit('success', $event), $event ? getReportList() : ''"
    @reportList="reportList = true"
  />
  <PopupCreateAlert
    ref="popupCreateAlert"
    :timeOption="this.buttonSelected"
    :elementOption="this.urlType"
    :parseDateRange="parseDateRange"
    :periodSelector="this.periodSelector"
    :selectHostName="this.hostName"
    selectHostContext="0"
    :startDate="startDate"
    :endDate="endDate"
    @activeBanner="$emit('activeBanner')"
    @successMsg="$emit('successMsg', $event)"
    @success="$emit('success', $event), $event ? getAlertList() : ''"
    @alertList="alertList = true"
  />
  <ask-confirmation-dialog
    ref="askConfirmationDialog"
  ></ask-confirmation-dialog>
  <TutorialCard
    v-if="this.$cookie.getCookie('API').includes('0585')"
    ref="tutorial"
    :timeOption="this.buttonSelected"
    :elementOption="this.urlType"
    :parseDateRange="parseDateRange"
    :periodSelector="this.periodSelector"
    :selectHostName="this.hostName"
    selectHostContext="0"
    :startDate="startDate"
    :endDate="endDate"
    @activeBanner="$emit('activeBanner')"
    @successMsg="$emit('successMsg', $event)"
    @success="$emit('success', $event), $event ? getAlertList() : ''"
    @alertList="alertList = true"
  ></TutorialCard>
  <EditReportRecipients
    ref="popupEditReport"
    @activeBanner="$emit('activeBanner')"
    @successMsg="$emit('successMsg', $event)"
    @success="$emit('success', $event), $event ? getReportList() : ''"
    @closeReportList="reportList = false"
  />
</template>

<script>
import {
  processQueueCoverage,
  processOverviewData,
  processStatusBreakdown,
} from "../../utils/performanceDataChartsProcess";

import LineChart from "../../components/PBX/PerformanceDashboard/LineChart.vue";
import BarChart from "../../components/PBX/PerformanceDashboard/BarChart.vue";
import AreaChart from "../../components/PBX/PerformanceDashboard/AreaChart.vue";
import HeatmapChart from "../../components/PBX/PerformanceDashboard/HeatmapChart.vue";
import DonutChart from "../../components/PBX/PerformanceDashboard/DonutChart.vue";
import RadialBarChart from "../../components/PBX/PerformanceDashboard/RadialBarChart.vue";
import RadialBarChartStroked from "../../components/PBX/PerformanceDashboard/RadialBarChartStroked.vue";

import EditReportRecipients from "../../components/PBX/EditReportRecipients.vue";
import NoData from "../../components/NoData.vue";
import PleaseSelectElement from "../../components/PleaseSelectElement.vue";
import PbxDashboardSelector from "../../components/PBX/PbxDashboardSelector.vue";
import AskConfirmationDialog from "../../components/AskConfirmationDialog.vue";
import PaginationComponent from "../../components/PaginationComponent.vue";
import PopupCreateAlert from "../../components/PBX/PopupCreateAlert.vue";
import PopupShareReportDashboard from "../../components/PBX/PopupShareReportDashboard.vue";
import axios from "axios";
import { mapGetters } from "vuex";
import TutorialCard from "../../components/PBX/Dashboard/TutorialCard.vue";
import TimeSelector from "../../components/PBX/TimeSelector";
import {
  Dialog,
  DialogPanel,
  DialogTitle,
  TransitionChild,
  TransitionRoot,
} from "@headlessui/vue";

const elementTypes = {
  0: "extension",
  1: "world",
  2: "undefined (2)",
  4: "queue",
  5: "voicemail",
  6: "ivr",
  8: "undefined (8)",
  9: "undefined (9)",
  12: "undefined (12)",
  13: "external_number_no_success",
  14: "call_flow",
  999: "not provided",
};

const calendarOptions = [
  {
    name: "yesterday",
    value: "yesterday",
    icon: "calendar-day",
  },
  {
    name: "this week",
    value: "currentWeek",
    icon: "calendar-week",
  },
  {
    name: "last week",
    value: "lastWeek",
    icon: "calendar-week",
  },
  {
    name: "this month",
    value: "currentMonth",
    icon: "calendar",
  },
  {
    name: "last month",
    value: "lastMonth",
    icon: "calendar",
  },
  {
    name: "last 3 months",
    value: "last3Months",
    icon: "calendar",
  },
  {
    name: "last 6 months",
    value: "last6Months",
    icon: "calendar",
  },
  {
    name: "personnalisé",
    value: "custom",
    icon: "calendar",
  },
];

export default {
  props: ["urlType", "showSideNav"],
  components: {
    PopupShareReportDashboard,
    PopupCreateAlert,
    Dialog,
    DialogPanel,
    DialogTitle,
    TransitionChild,
    TransitionRoot,
    PaginationComponent,
    AskConfirmationDialog,
    PbxDashboardSelector,
    PleaseSelectElement,
    NoData,
    TimeSelector,
    TutorialCard,
    EditReportRecipients,

    LineChart,
    BarChart,
    AreaChart,
    HeatmapChart,
    DonutChart,
    RadialBarChart,
    RadialBarChartStroked,
  },
  data() {
    return {
      reportEmails: [],
      reportId: null,
      showLessReport: [],
      showLessMail: [],
      currentMonthName: "",
      lastMonthName: "",
      currentYear: "",

      lineChartSeries: [],
      barChartSeries: [],
      areaChartSeries: [],
      heatmapSeries: [],
      radialSeries: [],
      timeSlots: [],

      statusBreakdownData: {
        labels: [],
        series: [],
      },

      connectionOverviewData: {
        labels: [],
        series: [],
      },

      queueConnectionOverviewData: {
        labels: [],
        series: [],
      },

      alertList: false,
      reportList: false,
      customDate: null,
      showDatePickers: false,
      period: "",
      calendarOptions,
      selectedPeriod: "",
      answerType: "hour",
      elementTypes,
      quickPeriodAnswered: "last 30 days",
      quickPeriodOrigin: "last 30 days",
      quickPeriodOriginTop: "last 30 days",
      defaultPeriod: 30,
      periodSelectorAnswered: null,
      periodSelectorOrigin: null,
      periodSelectorOriginTop: null,
      data: undefined,
      startDate: null,
      endDate: null,
      thead: [],
      tbody: [],
      theadAlert: [],
      tbodyAlert: [],
      currentSort: "id",
      currentSortDir: "asc",
      dataReports: undefined,
      dataAlerts: undefined,
      page: 1,
      pageAlerts: 1,
      selectedPbxElements: [],
      showLess: true,
      noDataForPeriod: false,
    };
  },
  methods: {
    selectPeriod(value) {
      this.selectedPeriod = value;
    },
    async setPeriod(val) {
      this.timeSlots = null;
      this.lineChartSeries = null;
      this.barChartSeries = null;
      this.areaChartSeries = null;
      this.heatmapSeries = null;

      this.statusBreakdownData = {
        labels: [],
        series: [],
      };

      this.connectionOverviewData = {
        labels: [],
        series: [],
      };

      this.queueConnectionOverviewData = {
        labels: [],
        series: [],
      };

      let period = "";
      if (
        this.$route.name === "DashboardExpertStatisticsTrend" ||
        this.$route.name === "DashboardTrend"
      ) {
        period = this.getLast12Months();
      } else {
        if (val === "currentWeek") {
          period = this.getCurrentWeek();
          this.customDate = null;
        } else if (val === "yesterday") {
          period = this.getYesterday();
          this.customDate = null;
        } else if (val === "day") {
          period = this.getCurrentDay();
          this.customDate = null;
        } else if (val === "lastWeek") {
          period = this.getLastWeek();
          this.customDate = null;
        } else if (val === "currentMonth") {
          period = this.getCurrentMonth();
          this.customDate = null;
        } else if (val === "lastMonth") {
          period = this.getLastMonth();
          this.customDate = null;
        } else if (val === "last3Months") {
          period = this.getLast3Months();
          this.customDate = null;
        } else if (val === "last6Months") {
          period = this.getLast6Months();
          this.customDate = null;
        } else {
          period = this.customDate;
        }
      }
      this.$store.dispatch("pbxPeriodSelected", val);
      this.$store.dispatch("pbxCustomDate", this.customDate);
      this.startDate =
        val === "custom"
          ? this.parseDateDayMonthYearHifen(period?.start)
          : period?.firstDay;
      this.endDate =
        val === "custom"
          ? this.parseDateDayMonthYearHifen(period?.end)
          : period?.lastDay;
      this.$emit("setPeriod", this.startDate, this.endDate);

      if (
        this.urlType ? this.pbxElements && this.pbxElements.length > 0 : true
      ) {
        this.$emit("setLoading", true);

        const [coverage, overview, status] = await Promise.all([
          this.getUserQueueCoverage(),
          this.getUserStatusOverview(),
          this.getUserStatusBreakdown(),
        ]);

        const {
          timeSlots,
          lineChartSeries,
          barChartSeries,
          areaChartSeries,
          heatmapSeries,
        } = processQueueCoverage(coverage, this.pbxMap);

        // const { donutSeries } = processOverviewData(overview.data[0]);

        // const heatmapSeries = processQueueCoverage(
        //  coverage,
        //  this.pbxMap
        // ).heatmapSeries;

        const processedStatusBreakdown = processStatusBreakdown(status);
        this.statusBreakdownData = processedStatusBreakdown;

        const processedPbxConnectionOverview = processOverviewData(
          overview.data[0],
        ).pbxConnectedSeries;
        this.connectionOverviewData = processedPbxConnectionOverview;

        const processedQueueConnectionOverview = processOverviewData(
          overview.data[0],
        ).queueConnectedSeries;
        this.queueConnectionOverviewData = processedQueueConnectionOverview;

        this.timeSlots = timeSlots;
        this.lineChartSeries = lineChartSeries;
        this.barChartSeries = barChartSeries;
        this.areaChartSeries = areaChartSeries;
        this.heatmapSeries = heatmapSeries;
        // this.donutSeries = donutSeries;
        // this.radialSeries = radialSeries;
      }
    },
    async getUserStatusOverview() {
      let data = null;
      let date = new Date();
      let year = date.getFullYear();
      let month = date.getMonth();
      let day = date.getDate();
      let start = this.formatDateApiRequest(
        this.getFirstDayOfMonth(year, month + 1),
      );

      let arrayOfElements = [];
      let stringOfElements = "";
      if (this.hostName) {
        if (
          (this.pbxElements && this.pbxElements?.length > 0) ||
          !this.urlType
        ) {
          this.pbxElements?.forEach((element, index) => {
            let elementValue = element;
            if (typeof elementValue === "object") {
              for (let index = 0; index < elementValue.length; index++) {
                const element = elementValue[index];
                arrayOfElements.push(element);
              }
            } else {
              arrayOfElements.push(element);
            }
          });

          arrayOfElements = [...new Set(arrayOfElements)];

          stringOfElements = String(arrayOfElements[0]);

          for (let index = 1; index < arrayOfElements.length; index++) {
            stringOfElements =
              stringOfElements + "," + String(arrayOfElements[index]);
          }

          let end = this.formatDateApiRequest(date);
          let url = `${this.$cookie.getCookie("API")}/api/v1.2/agent-stats/${
            this.hostName
          }/overview?start_date=${
            this.startDate ? this.startDate : start
          }&end_date=${this.endDate ? this.endDate : end}&start_time=${
            this.pbxTimeSelected[0]
          }&end_time=${this.pbxTimeSelected[1]}&user_dns=${
            this.pbxElements ? stringOfElements : ""
          }`;
          try {
            const res = await axios.get(url, {
              headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
              },
            });
            if (res.data?.data?.length == 0) {
              this.noDataForPeriod = true;
            } else {
              this.noDataForPeriod = false;
            }
            return res.data;
          } catch (error) {
            this.errorHandling(error);
          }
        }
      }
    },
    async getUserStatusBreakdown() {
      let data = null;
      let date = new Date();
      let year = date.getFullYear();
      let month = date.getMonth();
      let day = date.getDate();
      let start = this.formatDateApiRequest(
        this.getFirstDayOfMonth(year, month + 1),
      );

      let arrayOfElements = [];
      let stringOfElements = "";
      if (this.hostName) {
        if (
          (this.pbxElements && this.pbxElements?.length > 0) ||
          !this.urlType
        ) {
          this.pbxElements?.forEach((element, index) => {
            let elementValue = element;
            if (typeof elementValue === "object") {
              for (let index = 0; index < elementValue.length; index++) {
                const element = elementValue[index];
                arrayOfElements.push(element);
              }
            } else {
              arrayOfElements.push(element);
            }
          });

          arrayOfElements = [...new Set(arrayOfElements)];

          stringOfElements = String(arrayOfElements[0]);

          for (let index = 1; index < arrayOfElements.length; index++) {
            stringOfElements =
              stringOfElements + "," + String(arrayOfElements[index]);
          }

          let end = this.formatDateApiRequest(date);
          let url = `${this.$cookie.getCookie("API")}/api/v1.2/agent-stats/${
            this.hostName
          }/status-breakdown?start_date=${
            this.startDate ? this.startDate : start
          }&end_date=${this.endDate ? this.endDate : end}&start_time=${
            this.pbxTimeSelected[0]
          }&end_time=${this.pbxTimeSelected[1]}&user_dns=${
            this.pbxElements ? stringOfElements : ""
          }`;
          try {
            const res = await axios.get(url, {
              headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
              },
            });
            if (res.data?.data?.length == 0) {
              this.noDataForPeriod = true;
            } else {
              this.noDataForPeriod = false;
            }
            return res.data;
          } catch (error) {
            this.errorHandling(error);
          }
        }
      }
    },
    async getUserQueueCoverage() {
      let data = null;
      let date = new Date();
      let year = date.getFullYear();
      let month = date.getMonth();
      let day = date.getDate();
      let start = this.formatDateApiRequest(
        this.getFirstDayOfMonth(year, month + 1),
      );

      let arrayOfElements = [];
      let stringOfElements = "";
      if (this.hostName) {
        if (
          (this.pbxElements && this.pbxElements?.length > 0) ||
          !this.urlType
        ) {
          this.pbxElements?.forEach((element, index) => {
            let elementValue = element;
            if (typeof elementValue === "object") {
              for (let index = 0; index < elementValue.length; index++) {
                const element = elementValue[index];
                arrayOfElements.push(element);
              }
            } else {
              arrayOfElements.push(element);
            }
          });

          arrayOfElements = [...new Set(arrayOfElements)];

          stringOfElements = String(arrayOfElements[0]);

          for (let index = 1; index < arrayOfElements.length; index++) {
            stringOfElements =
              stringOfElements + "," + String(arrayOfElements[index]);
          }

          let end = this.formatDateApiRequest(date);
          let url = `${this.$cookie.getCookie("API")}/api/v1.2/agent-stats/${
            this.hostName
          }/queue-coverage/users?group_by_hour=1&start_date=${
            this.startDate ? this.startDate : start
          }&end_date=${this.endDate ? this.endDate : end}&start_time=${
            this.pbxTimeSelected[0]
          }&end_time=${this.pbxTimeSelected[1]}&user_dns=${
            this.pbxElements ? stringOfElements : ""
          }`;
          try {
            const res = await axios.get(url, {
              headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
              },
            });
            if (res.data?.data?.length == 0) {
              this.noDataForPeriod = true;
            } else {
              this.noDataForPeriod = false;
            }
            return res.data;
          } catch (error) {
            this.errorHandling(error);
          }
        }
      }
    },
    async getReportList() {
      this.$emit("setLoading", true);
      //  let reportType = this.getReportType();
      let reportType = null;
      let routeName = this.$route.name;
      let elementType = this.urlType ? (this.urlType === "queue" ? 4 : 0) : "*";
      if (routeName === "ExpertStatisticsDIDReport") {
        elementType = 4;
        reportType = this.getReportType();
      }
      let url = `${localStorage.getItem("apiUrl")}/api/v1.2/${
        this.hostName
      }/reports?page=${this.page}&filter[repeat]=1`;
      //&filter[report_type]=${reportType}&filter[element_type]=${elementType}
      try {
        const res = await axios.get(url, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("apiToken"),
          },
        });
        this.dataReports = res.data;

        if (res.data && res.data.data.length > 0) {
          const keyArr = Object.keys(res.data.data[0]);
          const excludedValues = [
            // "name",
            "host_name",
            "created_at",
            "updated_at",
            "start",
            "end",
            // "element_type",
            // "repeat_pattern",
            // "report_type",
            // "dns",
            "repeat",
            "instant",
            // "email",
            "email_sender",
            "pbx3cx_host_resource_group_id",
          ];
          const excludedValuesHead = [
            // "name",
            "host_name",
            "created_at",
            "updated_at",
            // "element_type",
            // "start_at",
            "start",
            "end",
            // "repeat_pattern",
            "repeat",
            "report_type",
            // "dns",
            "instant",
            // "email",
            "email_sender",
            "pbx3cx_host_resource_group_id",
          ];
          this.thead = keyArr
            .filter((name) => !excludedValuesHead.includes(name))
            .map((name) => ({ name, sort: "name", isSort: false }));

          this.tbody = res.data.data.map((obj) => {
            const filteredObj = Object.fromEntries(
              Object.entries(obj).filter(
                ([key]) => !excludedValues.includes(key),
              ),
            );
            return filteredObj;
          });
        }
      } catch (error) {
        this.errorHandling(error);
      } finally {
      }
      this.$emit("setLoading", false);
    },
    async getAlertList() {
      let url = `${localStorage.getItem("apiUrl")}/api/v1.2/${
        this.hostName
      }/alerts?page=${this.page}`;
      try {
        const res = await axios.get(url, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("apiToken"),
          },
        });
        this.dataAlerts = res.data;
        if (res.data && res.data.data.length > 0) {
          const keyArr = Object.keys(res.data.data[0]);
          const excludedValues = [
            "host_name",
            "created_at",
            "updated_at",
            "element_type",
            // "repeat_pattern",
            "report_type",
            "dns",
            "instant",
            "repeat",
            "email",
            "stats_type",
            "stats_measurement_type",
            "stats_measurement_limit",
            "stats_measurement_value",
            "end",
            "email_sender",
          ];
          const excludedValuesHead = [
            "host_name",
            "created_at",
            "updated_at",
            "element_type",
            "start_at",
            // "repeat_pattern",
            "report_type",
            "dns",
            "instant",
            "repeat",
            "email",
            "stats_type",
            "stats_measurement_type",
            "stats_measurement_limit",
            "stats_measurement_value",
            "end",
            "email_sender",
          ];
          this.theadAlert = keyArr
            .filter((name) => !excludedValuesHead.includes(name))
            .map((name) => ({ name, sort: "name", isSort: false }));

          this.tbodyAlert = res.data.data.map((obj) => {
            const filteredObj = Object.fromEntries(
              Object.entries(obj).filter(
                ([key]) => !excludedValues.includes(key),
              ),
            );
            return filteredObj;
          });
        }
      } catch (error) {
        this.errorHandling(error);
      } finally {
      }
    },
    nextPage() {
      if (this.page < this.dataReports?.last_page) {
        this.page = parseInt(this.page) + 1;
      } else {
        this.page = this.page;
      }
      this.getReportList();
    },
    previousPage() {
      if (this.page > this.dataReports?.last_page) {
        this.page = parseInt(this.page) - 1;
      } else {
        this.page = this.page;
      }
      this.getReportList();
    },
    async deleteItem(
      id,
      title,
      confirmationMessage,
      confirmButton,
      goBack,
      successMsg,
    ) {
      let url = `${localStorage.getItem("apiUrl")}/api/v1.2/${
        this.hostName
      }/reports/${id}`;
      const r = await this.$refs.askConfirmationDialog.show({
        title: title,
        message: confirmationMessage,
        okButton: confirmButton,
        cancelButton: goBack,
        action: "delete",
      });
      if (r) {
        axios
          .delete(url, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("apiToken")}`,
            },
          })
          .then((res) => {
            if (res) {
              // this.sendMessage(successMsg);
              this.$emit("activeBanner");
              this.$emit("success", true);
              this.$emit("successMsg", successMsg);
              this.getReportList();
            }
          })
          .catch((error) => {
            this.errorHandling(error);
            this.$emit("activeBanner");
            this.$emit("success", false);
            this.$emit("successMsg", this.errorDataResponse);
          });
      }
    },
    async deleteItemAlert(
      id,
      title,
      confirmationMessage,
      confirmButton,
      goBack,
      successMsg,
    ) {
      let url = `${localStorage.getItem("apiUrl")}/api/v1.2/${
        this.hostName
      }/alerts/${id}`;
      const r = await this.$refs.askConfirmationDialog.show({
        title: title,
        message: confirmationMessage,
        okButton: confirmButton,
        cancelButton: goBack,
        action: "delete",
      });
      if (r) {
        axios
          .delete(url, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("apiToken")}`,
            },
          })
          .then((res) => {
            if (res) {
              // this.sendMessage(successMsg);
              this.$emit("activeBanner");
              this.$emit("success", true);
              this.$emit("successMsg", successMsg);
              this.getAlertList();
            }
          })
          .catch((error) => {
            this.errorHandling(error);
            this.$emit("activeBanner");
            this.$emit("success", false);
            this.$emit("successMsg", this.errorDataResponse);
          });
      }
    },
    elementRemoved(element) {
      this.selectedPbxElements = this.pbxElements;
      let splitedElement = element.includes("-") ? element.split("-") : element;
      let elementValue = element.includes("-") ? splitedElement[0] : element;
      elementValue = elementValue.replace(/\s+/g, "");
      if (this.selectedPbxElements.indexOf(elementValue) >= 0) {
        this.selectedPbxElements.splice(
          this.selectedPbxElements.indexOf(elementValue),
          1,
        );
      }
      this.$store.dispatch("pbxElements", this.selectedPbxElements);
      this.setPeriod(this.selectedPeriod);
      //  this.$emit("action", this.selectedPbxElements);
    },
    setTimeSelected(event) {
      this.timeSelected = event;
    },
    changeTab(path) {
      this.$router.push(path).then(() => this.setPeriod(this.selectedPeriod));
    },
    nextPage() {
      if (parseInt(this.page) + 1 <= this.dataReports?.last_page) {
        this.page = this.page + 1;
      }
    },
    previousPage() {
      if (parseInt(this.page) - 1 >= 1) {
        // this.$router.push(`/expert-statistics/reports/${this.urlType}/${this.page - 1}`);
        this.page = this.page - 1;
      }
    },
    nextPageAlert() {
      if (parseInt(this.pageAlert) + 1 <= this.dataAlerts?.last_page) {
        this.pageAlert = this.pageAlert + 1;
      }
    },
    previousPageAlert() {
      if (parseInt(this.pageAlert) - 1 >= 1) {
        // this.$router.push(`/expert-statistics/reports/${this.urlType}/${this.pageAlert - 1}`);
        this.pageAlert = this.pageAlert - 1;
      }
    },
    parseDateRange(date) {
      if (date.length === 8) {
        let year = ("0" + date).slice(1, -4);
        let month = ("0" + date).slice(-4, -2);
        let day = ("0" + date).slice(-2);
        let fullDay = "";
        fullDay = day + "/" + month + "/" + year;
        return String(fullDay);
      } else if (date.length === 6) {
        let year = ("0" + date).slice(1, 5);
        let month = ("0" + date).slice(-2);
        let fullDay = "";
        fullDay = month + "/" + year;
        return String(fullDay);
      } else if (date.length === 17) {
        let fullDay = date.split("-");
        let firstYear = ("0" + fullDay[0]).slice(1, 5);
        let firstMonth = ("0" + fullDay[0]).slice(-4, -2);
        let firstDay = ("0" + fullDay[0]).slice(-2);

        let firstFullDay = "";
        firstFullDay = firstDay + "/" + firstMonth + "/" + firstYear;

        let lastYear = ("0" + fullDay[1]).slice(1, 5);
        let lastMonth = ("0" + fullDay[1]).slice(-4, -2);
        let lastDay = ("0" + fullDay[1]).slice(-2);

        let lastFullDay = "";
        lastFullDay = lastDay + "/" + lastMonth + "/" + lastYear;
        let finalDay = "";
        finalDay = firstFullDay + " - " + lastFullDay;
        return String(finalDay);
      } else {
        return date;
      }
    },
    calculateTrends() {
      this.setCurrentMonthAndYear();

      // Calculate percentage change from previous month
      this.carTrend = (
        ((this.carCalls - this.prevCarCalls) / this.prevCarCalls) *
        100
      ).toFixed(1);
      this.totalTrend = (
        ((this.totalCalls - this.prevTotalCalls) / this.prevTotalCalls) *
        100
      ).toFixed(1);
      this.answeredTrend = (
        ((this.answeredCalls - this.prevAnsweredCalls) /
          this.prevAnsweredCalls) *
        100
      ).toFixed(1);
      this.unansweredTrend = (
        ((this.unansweredCalls - this.prevUnansweredCalls) /
          this.prevUnansweredCalls) *
        100
      ).toFixed(1);
      this.waitTimeTrend = (
        ((this.averageWaitTime - this.prevAverageWaitTime) /
          this.prevAverageWaitTime) *
        100
      ).toFixed(1);
    },
    setCurrentMonthAndYear() {
      // Create a new Date object
      const date = new Date();

      // Get the current year

      // Get the current month name
      const monthNames = [
        "janvier",
        "février",
        "mars",
        "avril",
        "mai",
        "juin",
        "juillet",
        "août",
        "septembre",
        "octobre",
        "novembre",
        "décembre",
      ];
      this.currentYear =
        date.getMonth() > 0
          ? date.getFullYear().toString().slice(-2)
          : parseInt(date.getFullYear().toString().slice(-2)) - 1; // '24' for 2024
      this.currentMonthName =
        monthNames[date.getMonth() > 0 ? date.getMonth() - 1 : 11]; // Get month as name

      this.lastMonthName =
        monthNames[
          date.getMonth() > 1
            ? date.getMonth() - 2
            : date.getMonth() == 1
            ? 0
            : 10
        ]; // Get
    },
  },
  mounted() {
    if (
      localStorage.getItem("dashboard_tutorial") == 1 &&
      this.$route.name === "Dashboard" &&
      this.$cookie.getCookie("API").includes("0585")
    ) {
      this.$refs.tutorial.show();
    }
    this.$store.dispatch("groupSelected", false);
    this.$store.dispatch("groupSelectedName", []);
    this.$store.dispatch("pbxElements", null);
    // this.getDataFromElementForColumn(
    //  this.periodSelectorAnswered
    //   ? this.periodSelectorAnswered
    //   : this.defaultPeriod
    // );
    // this.getDataFromElementOrigins(this.periodSelectorOrigin ? this.periodSelectorOrigin : this.defaultPeriod);
    // this.getDataFromElementOriginsTop(this.periodSelectorOriginTop ? this.periodSelectorOriginTop : this.defaultPeriod);
    // this.getDataTopQueues();
    if (this.pbxPeriodSelected) {
      if (this.pbxPeriodSelected === "custom" && this.pbxCustomDate) {
        this.customDate = this.pbxCustomDate;
      }
      this.selectedPeriod = this.pbxPeriodSelected;
    } else {
      this.selectedPeriod = "lastMonth";
    }
    // this.getReportList();
    // this.getAlertList();
  },
  created() {},
  computed: {
    ...mapGetters([
      "account",
      "pbxElements",
      "pbxTimeSelected",
      "hostName",
      "hostContext",
      "hostTimeZone",
      "pbxElementType",
      "pbxPeriodSelected",
      "pbxMap",
      "pbxCustomDate",
    ]),
  },

  watch: {
    urlType: function (val) {
      this.$store.dispatch("pbxElements", null);
      this.$store.dispatch("groupSelected", false);
      this.$store.dispatch("groupSelectedName", []);
      this.setPeriod(this.selectedPeriod);
      this.getReportList();
      this.getAlertList();
    },
    page: function (val) {
      this.getReportList();
    },
    selectedPeriod: function (val) {
      this.setPeriod(val);
    },
    customDate: function (val) {
      if (val) {
        if (this.selectedPeriod === "custom") {
          this.setPeriod("custom");
        } else {
          this.selectedPeriod = "custom";
        }
      }
    },
    periodSelectorAnswered: function (val) {
      //  this.getDataFromElementForColumn(val);
    },
    periodSelectorOrigin: function (val) {
      //  this.getDataFromElementOrigins(val);
    },
    periodSelectorOriginTop: function (val) {
      //  this.getDataFromElementOriginsTop(val);
    },
  },
};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
}
.beta__logo {
  left: 22rem;
}
</style>
